// styleLoader.js
export async function loadSmartStyles(styleUrl) {
  const response = await fetch(styleUrl);
  const styles = await response.json();

  const root = document.documentElement;
  Object.entries(styles).forEach(([key, value]) => {
    if (value && value.trim() !== "") {
      root.style.setProperty(`--${key.replace(/_/g, "-")}`, value);
    }
  });
}
